import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription, Observable } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import * as InvitationsActions from 'src/app/store/invitations/invitations.actions';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { selectInvitationsAccepted, selectInvitationsAccepting, selectInvitationsItemsPaginationList, selectInvitationsList, selectInvitationsRejected, selectInvitationsRejecting } from 'src/app/store/invitations/invitations.selector';
import { Invitations } from 'src/app/model/invitations';
import { INVITATIONS_PAGE_DEFAULT_SIZE, INVITATIONS_TYPE } from 'src/app/conf/invitations';
import { FormControl, FormGroup } from '@angular/forms';
import { ItemsPagination } from 'src/app/model/api/data-rest';
import { PaginationParams } from 'src/app/model/api/pagination-params';

@Component({
	selector: 'app-invitations-dialog',
	templateUrl: './invitations-dialog.component.html',
	providers: [],
})

export class InvitationsDialogComponent implements OnInit, OnDestroy {
	invitationsList$: Observable<Invitations[] | undefined>;
	invitationsListSub: Subscription | undefined;
	invitationsList: Invitations[];

	// invitationsListFilter: Invitations[];

	invitationsItemsPagination$: Observable<ItemsPagination | undefined>;
	invitationsItemsPaginationSub: Subscription | undefined;

	// currentUser: User;
	// currentUser$: Observable<User | undefined>;
	// currentUserSub: Subscription | undefined;

	pageSize = INVITATIONS_PAGE_DEFAULT_SIZE;
	totalRecords: number = 0;

	loading: boolean;

	GROUP_TH_SHARE = INVITATIONS_TYPE.GROUP_TH_SHARE;

	filterForm: FormGroup;
	filterSub: Subscription;

	invitationsAccepting$: Observable<boolean | undefined>;
	invitationsAcceptingSub: Subscription | undefined;
	invitationsRejecting$: Observable<boolean | undefined>;
	invitationsRejectingSub: Subscription | undefined;

	invitationsAccepted$: Observable<boolean | undefined>;
	invitationsAcceptedSub: Subscription | undefined;
	invitationsRejected$: Observable<boolean | undefined>;
	invitationsRejectedSub: Subscription | undefined;

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	COLUMN_TITLE_MIN_WD = 647;
	acceptButtonStyle: string;
	rejectButtonStyle: string;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.invitationsList$ = this.store.select(selectInvitationsList);
		this.invitationsItemsPagination$ = this.store.select(selectInvitationsItemsPaginationList);
		// this.currentUser$ = this.store.select(selectUser);
		this.invitationsAccepting$ = this.store.select(selectInvitationsAccepting);
		this.invitationsRejecting$ = this.store.select(selectInvitationsRejecting);
		this.invitationsAccepted$ = this.store.select(selectInvitationsAccepted);
		this.invitationsRejected$ = this.store.select(selectInvitationsRejected);
	}

	ngOnInit(): void {
		this.filterForm = new FormGroup({
			// 'searchFilter': new FormControl(''),
			'statusReceiver': new FormControl(true),
			'statusSender': new FormControl(false),
		});

		this.subscribeAll();
		this.onResize();
	}

	subscribeAll(): void {
		this.invitationsListSub = this.invitationsList$?.subscribe(
			(invitationsList) => {
				this.invitationsList = invitationsList;
				this.loading = false;
			}
		);
		this.invitationsItemsPaginationSub = this.invitationsItemsPagination$?.subscribe(
			(invitationsItemsPagination) => {
				this.totalRecords = invitationsItemsPagination.TotalCount;
			}
		);
		// this.currentUserSub = this.currentUser$?.subscribe(currentUser => {
		// 	this.currentUser = currentUser;
		// });
		this.invitationsAcceptingSub = this.invitationsAccepting$?.subscribe(
			(invitationsAccepting) => {
				this.loading = invitationsAccepting;
			}
		);
		this.invitationsRejectingSub = this.invitationsRejecting$?.subscribe(
			(invitationsRejecting) => {
				this.loading = invitationsRejecting;
			}
		);
		this.invitationsAcceptedSub = this.invitationsAccepted$?.subscribe(
			(accepted) => {
				if (accepted) {
					this.filterList();
				}
			}
		);
		this.invitationsRejectedSub = this.invitationsRejected$?.subscribe(
			(rejected) => {
				if (rejected) {
					this.filterList();
				}
			}
		);
		this.filterSub = this.filterForm.valueChanges.subscribe(() => {
			this.loading = true;
			setTimeout(() => {
				this.filterList();
			}, 500);
		});
	}

	ngOnDestroy(): void {
		this.invitationsListSub?.unsubscribe();
		this.invitationsItemsPaginationSub?.unsubscribe();
		// this.currentUserSub?.unsubscribe();
		this.invitationsAcceptingSub?.unsubscribe();
	}

	onPageChange(event: { first?: number; rows?: number }): void {
		const size = event.rows ?? this.pageSize;
		const page = Math.floor((event.first ?? 0) / size) + 1;

		this.loading = true;
		this.store.dispatch(InvitationsActions.getInvitationsPaginatedList({
			paging: { page, size },
			pending: true,
			created: this.f.statusSender.value,
			invited: this.f.statusReceiver.value,
		}));
	}

	getInvitationsTypeTxt(invitation: Invitations): string {
		switch (invitation.Type) {
			case INVITATIONS_TYPE.DEVICE_SHARE: {
				return 'INVITATIONS_TYPE_DEVICE_SHARE';
			}
			case INVITATIONS_TYPE.TRANSFER_SITE: {
				return 'INVITATIONS_TYPE_TRANSFER_SITE';
			}
			case INVITATIONS_TYPE.ADD_CUSTOMER: {
				return 'INVITATIONS_TYPE_ADD_CUSTOMER';
			}
			case INVITATIONS_TYPE.GROUP_TH_SHARE: {
				return 'INVITATIONS_TYPE_HOUSE_TH_SHARE';
			}
		}
		return '';
	}

	getInvitationsTypeIcon(invitation: Invitations): string {
		switch (invitation.Type) {
			case INVITATIONS_TYPE.DEVICE_SHARE: {
				return 'pi cm-devices';
			}
			case INVITATIONS_TYPE.TRANSFER_SITE: {
				return 'pi cm-installation';
			}
			case INVITATIONS_TYPE.ADD_CUSTOMER: {
				return 'pi cm-technician';
			}
			case INVITATIONS_TYPE.GROUP_TH_SHARE: {
				return 'pi cm-termo';
			}
		}
		return 'danger';
	}

	getInvitationsDetails(invitation: Invitations): string {
		switch (invitation.Type) {
			case INVITATIONS_TYPE.DEVICE_SHARE: {
				return this.translate.instant('DEVICE') + ': ' + invitation.DeviceName;
			}
			case INVITATIONS_TYPE.TRANSFER_SITE: {
				return this.translate.instant('INSTALLATION') + ': ' + invitation.SiteName;
			}
			case INVITATIONS_TYPE.ADD_CUSTOMER: {
				return this.translate.instant('ADD_CUSTOMER_TECNICIAN');
			}
			case INVITATIONS_TYPE.GROUP_TH_SHARE: {
				return this.translate.instant('HOUSE') + ': ' + invitation.MongoGroupName;
			}
		}
		return '';
	}

	getSenderTypeIcon(invitation: Invitations): string {
		switch (invitation.Type) {
			case INVITATIONS_TYPE.DEVICE_SHARE: {
				return 'pi cm-user';
			}
			case INVITATIONS_TYPE.TRANSFER_SITE: {
				return 'pi cm-technician';
			}
			case INVITATIONS_TYPE.ADD_CUSTOMER: {
				return 'pi cm-technician';
			}
			case INVITATIONS_TYPE.GROUP_TH_SHARE: {
				return 'pi cm-user';
			}
		}
		return '';
	}

	getSenderSeverity(invitation: Invitations): string {
		if (this.receiverInvitation(invitation)) {
			return 'primary';
		}
		// switch (invitation.Type) {
		// 	case INVITATIONS_TYPE.DEVICE_SHARE: {
		// 		return 'primary';
		// 	}
		// 	case INVITATIONS_TYPE.TRANSFER_SITE: {
		// 		return 'warning';
		// 	}
		// 	case INVITATIONS_TYPE.ADD_CUSTOMER: {
		// 		return 'warning';
		// 	}
		// 	case INVITATIONS_TYPE.GROUP_TH_SHARE: {
		// 		return 'primary';
		// 	}
		// }
		return '';
	}

	get f(): any {
		return this.filterForm.controls;
	}

	filterList(): void {
		const created : boolean = this.f.statusSender.value;
		const invited : boolean = this.f.statusReceiver.value;
		const invitationsPaging : PaginationParams = { page: 1, size: INVITATIONS_PAGE_DEFAULT_SIZE };
		this.store.dispatch(InvitationsActions.getInvitationsPaginatedList({ paging: invitationsPaging, pending: true, created: created, invited: invited }));
	}

	filterStatus(invitation: Invitations): boolean {
		if (this.f.statusReceiver.value && invitation.CreatorEmail !== undefined) { // receiver
			return true;
		}
		if (this.f.statusSender.value && (invitation.CreatorEmail === undefined || invitation.CreatorEmail === null)) { // sender
			return true;
		}
		return false;
	}

	receiverInvitation(invitation: Invitations): boolean {
		if (this.f.statusReceiver.value && invitation.CreatorEmail !== undefined) { // receiver
			return true;
		}
		return false;
	}

	getEmailInvitation(invitation: Invitations): string {
		if (this.receiverInvitation(invitation)) {
			return invitation.CreatorEmail;
		} else {
			return invitation.InvitedUserEmail;
		}
	}

	acceptInvite(invitation: Invitations): void {
		this.store.dispatch(InvitationsActions.invitationsAccept({ token: invitation.Token }));
	}

	rejectInvite(invitation: Invitations): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('REJECT_INVITATION'),
			message: this.translate.instant('REJECT_INVITATION_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(InvitationsActions.invitationsReject({ token: invitation.Token }));
				// this.closeDialog();
			},
			reject: () => {
			}
		});
	}

	closeDialog(): void {
		this.ref.close();
	}


	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underTablet(): boolean {
		return this.screenWidth <= 960;
		// return StandardPageLayout.underTablet(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}
